(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-music-lookbook-b"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-c"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-feb23"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-feb25"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-mar24"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-nov23"]) return;
  try {
    

  
var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-oct24"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-oct25"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-oslo22"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-so26"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music-lookbook-summer22"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};


    window.onload=function(){

    var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) {
        



document.getElementById("bg_music_control").innerHTML = '<i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

document.getElementById("bg_music_control").setAttribute("style", "top: 17%;left: 3.5%;right: auto;bottom: auto;");

    } else {


    }
  }




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-music"]) return;
  try {
    

var myAudio = document.getElementById("lookbook_bg_music");

if (myAudio.duration == 0 && myAudio.paused) {
	myAudio.play();
}

document.getElementById('bg_music_control').onclick = function(){

var myAudio = document.getElementById("lookbook_bg_music");

console.log(myAudio);

if (myAudio.duration > 0 && !myAudio.paused) {
	myAudio.pause();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-up fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';
	//Its playing...do your job

} else {

	myAudio.play();
	document.getElementById("bg_music_control").innerHTML = '  <i class="fa fa-volume-off fa-2x"></i> <a id="bg_music_control_text" style="vertical-align: text-bottom;" href="javascript:;"></a>';

}

};



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-color-palette"] && !Shopify.designMode) return;
  try {
    
var elem = document.querySelector('.cpc23');
var flkty = new Flickity( elem, {
    "prevNextButtons": true,
    "pageDots": false,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center",
    "watchCSS": true,
    "dragThreshold": 8,
    "groupCells": true,
    "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});

  } catch(e) { console.error(e); }
})();
})();
